export default {
	"order.NoRelevantOrderInformationYet": "還沒有相關訂單信息",
	"order.TradingClosed": "交易關閉",
	"order.YouHaveSuccessfullyAppliedPleaseCheckTheOrderStatusLater": "您已成功申請，請稍後查看訂單狀態",
	"order.TheSystemIsDeserted": "系統開小差啦！",
	"order.SignUpAndPayNow": "立即簽約支付",
	"order.ApplyForADeduction": "申請扣款",
	"order.callOfficial": "叫叫官方",
	"order.ThisTimeYouOnlyNeedToPayTheTransferFee": "本次僅需支付轉單費用：",
	"order.growBeans": "成長豆",
	"order.OrderHasBeenTransferred": "已轉單",
	"order.total": "共計：",
	"order.openRecord": "開通記錄",
	"order.ChangeAddress": "修改地址",
	"order.fillInTheAddress": "填寫地址",
	"order.ViewLogistics": "查看物流",
	"order.ImmediatePayment": "立即付款",
	"order.loadMore": "加載更多",
	"order.noMore": "沒有更多了",
	"order.hint": "提示",
	"order.understood": "知道了",
	"order.ToPayForTheOrderPleasePayInTheOrderLogisticsOfTheCallOfficialAccount": "支付該訂單請在【叫叫】公眾號的訂單物流中進行支付",
	"order.PleaseEnsureThatYourContractAccountBalanceIsSufficientBeforeMakingADeductionApplication": "請保障您的簽約賬戶餘額充足後再進行扣款申請",
	"order.Cancel": "取消"
}